import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-signup',
  templateUrl: './breadcrumb-signup.component.html',
  styleUrls: ['./breadcrumb-signup.component.scss']
})
export class BreadcrumbSignupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
